<app-pan-modal [isOpen]="isVisible()" (modalWillOpen)="load()" (modalClose)="isVisible.set(false)" data-testid="review-notes-modal">
  <div header>Review Notes</div>

  <div body class="flex flex-col gap-4">
    <app-pan-inline-alert type="info">These notes will be visible to our investigators.</app-pan-inline-alert>

    @if (loading()) {
      <app-pan-blank-slate data-testid="review-notes-loading">
        <app-pan-spinner></app-pan-spinner> &nbsp;Loading notes...
      </app-pan-blank-slate>
    } @else {
      <app-pan-form-control>
        <app-pan-floating-label for="reviewNotes">Location Name: {{ locationName() }}</app-pan-floating-label>
        <textarea
          panTextarea
          id="reviewNotes"
          rows="6"
          [maxlength]="maxLength"
          [disabled]="saving() || !reviewNotes()"
          [(ngModel)]="notes"
          data-testid="review-notes-textarea"
        ></textarea>
      </app-pan-form-control>
    }

    @if (lastUpdate(); as lastUpdate) {
      <span class="text-sm text-gray-600 italic" data-testid="review-notes-last-updated">
        Last updated by {{ lastUpdate.by }} at {{ lastUpdate.at | date: "medium" }}
      </span>
    }
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose color="default" data-testid="review-notes-cancel" [disabled]="saving()">Cancel</button>
    <button panButton color="primary" data-testid="review-notes-save" [disabled]="saving() || !reviewNotes()" (click)="save()">
      {{ saving() ? "Saving..." : "Save Note" }}
    </button>
  </div>
</app-pan-modal>
